import "@/App.css";
import "@/motion.css";
import MotionRuntime from "@/components/motion/MotionRuntime";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import NewReservation from "@/pages/admin/NewReservation";
import ReservationDetail from "@/pages/admin/ReservationDetail";
import Products from "@/pages/admin/Products";
import Finance from "@/pages/admin/Finance";
import ReturnChecklist from "@/pages/admin/ReturnChecklist";
import ClientWelcome from "@/pages/client/Welcome";
import ClientCheckin from "@/pages/client/Checkin";
import ClientCheckout from "@/pages/client/Checkout";
import ClientSelfPickup from "@/pages/client/SelfPickup";
import PaymentResult from "@/pages/client/PaymentResult";
import ClientReturnPrep from "@/pages/client/ReturnPrep";
import { Aurora, AuroraDefs } from "@/components/motion/Aurora";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="aurora-page relative isolate min-h-screen bg-ivory flex items-center justify-center text-warmgray">
        <Aurora variant="light" fixed />
        Cargando...
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" richColors closeButton />
        <BrowserRouter>
          <MotionRuntime />
          <AuroraDefs />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <Protected>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/admin/reservations/new"
              element={
                <Protected>
                  <NewReservation />
                </Protected>
              }
            />
            <Route
              path="/admin/reservations/:id"
              element={
                <Protected>
                  <ReservationDetail />
                </Protected>
              }
            />
            <Route
              path="/admin/productos"
              element={
                <Protected>
                  <Products />
                </Protected>
              }
            />
            <Route
              path="/admin/finanzas"
              element={
                <Protected>
                  <Finance />
                </Protected>
              }
            />
            <Route
              path="/admin/checklist"
              element={
                <Protected>
                  <ReturnChecklist />
                </Protected>
              }
            />
            <Route path="/reserva/:code" element={<ClientWelcome />} />
            <Route path="/checkin/:code" element={<ClientCheckin />} />
            <Route path="/recogida/:code" element={<ClientSelfPickup />} />
            <Route path="/checkout/:code" element={<ClientCheckout />} />
            <Route path="/devolucion/:code" element={<ClientReturnPrep />} />
            <Route path="/pago/:result" element={<PaymentResult />} />
            <Route path="/pago-extras/:result" element={<PaymentResult kind="extras" />} />
            <Route path="/pago-alquiler/:result" element={<PaymentResult kind="rental" />} />
            <Route path="/pago-senal/:result" element={<PaymentResult kind="signal" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
